<ng-container *ngTemplateOutlet="isDesktop ? desktop : mobile"></ng-container>

<ng-template #desktop>

    <div *ngIf="!isPPMD">
        <employee-request-details-desktop *isUS [requestData]="requestData"
            [requestReasonPayload]="requestReasonPayload" [tabs]="tabs" [locationFilterConfig]="locationFilterConfig"
            (onLocationSelect)="locationChanged($event)" (onRequestReasonSelect)="pickRequestReason($event)"
            (onPreferredFullNameSelected)="preferredFullNameSelected($event)"
            (onBloodGroupSelected)="bloodGroupSelected($event)">
        </employee-request-details-desktop>
    </div>

    <div *ngIf="isPPMD">
        <ppmd-employee-request-details-desktop *isUS [requestData]="requestData"
            [requestReasonPayload]="requestReasonPayload" [tabs]="tabs" [locationFilterConfig]="locationFilterConfig"
            (onLocationSelect)="locationChanged($event)" (onRequestReasonSelect)="pickRequestReason($event)"
            (onPreferredFullNameSelected)="preferredFullNameSelected($event)"
            (onBloodGroupSelected)="bloodGroupSelected($event)"
            (onPPMDUserSelected)="ppmdUserSelected($event)">
        </ppmd-employee-request-details-desktop>
    </div>

    <employee-request-details-desktop-usi *isUSI [requestData]="requestData"
        [requestReasonPayload]="requestReasonPayload" [tabs]="tabs" [visitorsTabs]="visitorsTabs"
        [locationFilterConfig]="locationFilterConfig" (onLocationSelect)="locationChanged($event)"
        (onRequestReasonSelect)="pickRequestReason($event)"
        (onPreferredFullNameSelected)="preferredFullNameSelected($event)"
        (onBloodGroupSelected)="bloodGroupSelected($event)">
    </employee-request-details-desktop-usi>





</ng-template>

<ng-template #mobile>
    <employee-request-details-mobile [requestData]="requestData" [requestReasonPayload]="requestReasonPayload"
        [tabs]="tabs" (onLocationSelect)="locationChanged($event)" (onRequestReasonSelect)="pickRequestReason($event)"
        (onPreferredFullNameSelected)="preferredFullNameSelected($event)"
        (onBloodGroupSelected)="bloodGroupSelected($event)">
    </employee-request-details-mobile>
</ng-template>

<!-- <badge-type-selection-modal
  *ngIf="showBadgeTypePopup"
  (selectType)="onBadgeTypeSelected($event)"
  (close)="onBadgeTypeModalClose()">
</badge-type-selection-modal> -->